import I18n from 'I18n';
import StateConstants from '../constants/StateConstants';
export const DEFAULT_ARTICLE_NAME = 'What question is your article answering?';
export const getDefaultArticleName = useI18n => useI18n ? I18n.text('knowledgeContentUI.edit.fields.title.placeholder') : 'What question is your article answering?';
export function getArticleNamePlaceholder() {
  return I18n.text('knowledgeContentUI.edit.fields.title.placeholder');
}
export function isPublished(article) {
  return article && article.values.hs_state === StateConstants.PUBLISHED;
}
export function areAllVariantsPublished(article) {
  const {
    translations
  } = article;
  const translationValues = Object.values(translations);
  const hasUnpublishedVariants = translationValues.some(translation => translation.values.hs_state !== StateConstants.PUBLISHED);
  return !hasUnpublishedVariants;
}